import { render, staticRenderFns } from "./PointCreditTechcoinCancel.vue?vue&type=template&id=40646aaa"
import script from "./PointCreditTechcoinCancel.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoinCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports